import SelectLanguage from '@/components/account/SelectLanguage';
import Container from '@/components/shared/Container';
import { getFooterItems } from '@/core/lib/api/main/menu-api';

import FooterList from './FooterList';
import Newsletter from './Newsletter';
import SocialMedia from './SocialMedia';
import Link from 'next/link';
import Image from 'next/image';
import { getSettings } from '@/core/lib/api/main/setting';

export default async function Footer() {
  const footerItems = await getFooterItems();
  const setting = await getSettings();


  return (
    <div className='bg-primary-900 mt-10'>
      <Container className="py-8 print:hidden gap-y-10">
        <div className="flex md:items-center md:justify-between max-md:flex-col max-md:space-y-8">
          <div>
            <Link
              href="/"
              className="h-full"
            >
              {setting.logo_footer && (
                <Image
                  src={setting.logo_footer}
                  alt={setting.site_title || "Logo"}
                  width={140}
                  height={70}
                  className="object-contain flex"
                />
              )}
            </Link>
          </div>
          <Newsletter />
        </div>

        <div className='mt-17 mb-17 h-px bg-primary-0/15' />
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12">
            <FooterList footerItems={footerItems} setting={setting} />
          </div>
        </div>
        <div className="flex items-center justify-center mt-8">
          <SelectLanguage />
        </div>
        <div className='flex items-center justify-between'>
          <SocialMedia iconColor='#fff' />
        </div>

      </Container>
    </div>
  );
}
